<template lang="html">
  <div class="">
    <div id="json-editor" class="">

    </div>
    <button id="get-result" @click="getResult">get result</button>
    <div id="result"></div>
  </div>
</template>

<script>
import 'json-editor'
let JSONEditor = window.JSONEditor
let $ = window.$
import chapters from '../assets/chapters.json'
export default {
  mounted () {
    let element = document.getElementById('json-editor')
    let options = {
      schema: {
        type: 'array',
        title: 'Languages',
        items: {
          type: 'object',
          title: 'language',
          properties: {
            language: {type: 'string'},
            chapters: {
              type: 'array',
              title: 'Chapters',
              items: {
                type: 'object',
                title: 'Chapter',
                properties: {
                  title: {type: 'string'},
                  key: {type: 'string'},
                  intro: {
                    type: 'string',
                    format: 'textarea',
                    options: {input_height: '100px'}
                  },
                  subChapters: {
                    type: 'array',
                    title: 'sub chapters',
                    items: {
                      type: 'object',
                      title: 'sub chapter',
                      properties: {
                        title: {type: 'string'},
                        block: {
                          type: 'object',
                          properties: {
                            text: {
                              type: 'string',
                              format: 'textarea',
                              options: {input_height: '100px'}
                            },
                            explainers: {
                              type: 'array',
                              items: {
                                title: 'explainer',
                                type: 'object',
                                properties: {
                                  keyword: {type: 'string'},
                                  text: {
                                    type: 'string',
                                    format: 'textarea',
                                    options: {input_height: '100px'}
                                  }
                                }
                              }
                            },
                            image: {type: 'string'}
                          }
                        },
                        pointers: {
                          type: 'array',
                          items: {
                            type: 'object',
                            title: 'pointer',
                            properties: {
                              title: {type: 'string'},
                              subtitle: {type: 'string'}
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    let editor = new JSONEditor(element, options)
    editor.setValue(chapters)
    console.log(editor)
    window.editor = editor
  },
  methods: {
    getResult () {
      console.log('getrestult')
      $('#result').html(JSON.stringify(window.editor.getValue()))
    }
  }
}
</script>

<style lang='css'>
#json-editor {
  text-align: left;
  position: absolute;
  overflow-y: scroll;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
#get-result {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
}
#result {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue